import { useQuery } from '@tanstack/react-query'

import { type SetType } from '@/defs/set'
import { fetchApi } from '@/utils/requestUtil'

const CONFIG = {
  setsRecent: () => fetchApi<SetType[]>({ base: 'jsonCloudflare', path: '/static/sets-recent' }),
}

export const useFetchStatic = (slug: keyof typeof CONFIG) =>
  useQuery({
    queryFn: async () => (await CONFIG[slug]()).data,
    queryKey: [`static-${slug}`],
  })
